import { Injectable } from '@angular/core';
import { extend, isArray, map, reduce } from 'lodash';
import {
  IAnalyticsOptions,
  ITrackingAction,
  ITrackingObject,
  ITrackingProperties,
} from './models/tracking.data';

@Injectable()
export class I2gNgTrackingBuilder {
  constructor() {}

  buildContext(options: IAnalyticsOptions, traits?: ITrackingProperties) {
    return {
      context: {
        app: {
          version: options.app_version,
          name: options.app_name,
        },
        traits,
      },
    };
  }

  buildTrackingEvent(
    trackingObjects: ITrackingObject | ITrackingObject[],
    trackingAction: ITrackingAction,
    additionalProperties?: any
  ) {
    const trackingObjectsName = isArray(trackingObjects)
      ? map(trackingObjects, (trackingObject) => trackingObject.name).join('_')
      : (trackingObjects as ITrackingObject).name;

    const trackingObjectsProperties = isArray(trackingObjects)
      ? reduce(
          trackingObjects,
          (result, trackingObject) => {
            extend(result, trackingObject.properties);

            return result;
          },
          {}
        )
      : (trackingObjects as ITrackingObject).properties;

    return {
      name: [trackingObjectsName, trackingAction.name].join('_'),
      properties: {
        ...trackingObjectsProperties,
        ...trackingAction.properties,
        ...additionalProperties,
      },
    };
  }
}
